import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import EbdaEduNavbar from "components/navbars/EbdaEduNavbar";
import { CLASS_STATUS } from "constants/constants";
import { useLanguage } from "context/LanguageContext";
import { useTheme } from "context/ThemeContext";
import { saveAs } from "file-saver";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import * as XLSX from "xlsx";
import { createClass, createClassRoom, uploadClassRoomDocument } from "services/admins";
import { signUpUser } from "services/auth";
import {
  fetchWatomsRelatedCoursesDetailed,
} from "services/watoms/watomsData";
import { fetchWisdomRelatedClassRooms, fetchWisdomRelatedSchools, fetchWisdomRelatedSpecializations, fetchWisdomStages } from "services/wisdom/wisdomData";
import { useEbdaEduAuth } from "context/EbdaEduAuthContext";

const WabysBulkStudents = () => {
  const { language } = useLanguage();
  const { darkMode } = useTheme();
  const { ebdaUserInfo } = useEbdaEduAuth();

  const [courses, setCourses] = useState([]);
  const [filteredCourses, setFilteredCourses] = useState([]);
  const [specializations, setSpecializations] = useState([]);
  const [filteredSpecializations, setFilteredSpecializations] = useState([]);
  const [schools, setSchools] = useState([]);
  const [classRooms, setClassRooms] = useState([]);
  const [filteredClassRooms, setFilteredClassRooms] = useState([]);
  const [stages, setStages] = useState([]);

  const [openForm, setOpenForm] = useState(null); // "classroom" | "class" | null
  // ------- Add Classroom -------
  const [newClassRoomName, setNewClassRoomName] = useState("");
  const [newClassRoomOrgId, setNewClassRoomOrgId] = useState("");
  const [newRoomType, setNewRoomType] = useState("class");

  // ------- Add Class -------
  const [newClassName, setNewClassName] = useState("");
  const [newClassRoomId, setNewClassRoomId] = useState("");
  const [newSpecializationId, setNewSpecializationId] = useState("");
  const [stageId, setStageId] = useState("");
  const [newStartDate, setNewStartDate] = useState("");
  const [newEndDate, setNewEndDate] = useState("");
  const [newHours, setNewHours] = useState("");
  const [newMale, setNewMale] = useState("");
  const [newFemale, setNewFemale] = useState("");
  const [newStatus, setNewStatus] = useState("");

  // ------- Add Classroom Document -------
  const [docOrgId, setDocOrgId] = useState("");
  const [docRoomType, setDocRoomType] = useState("class");
  const [docClassRoomId, setDocClassRoomId] = useState("");
  const [filteredDocClassRooms, setFilteredDocClassRooms] = useState([]);
  const [docFile, setDocFile] = useState(null);
  const [docFileName, setDocFileName] = useState("");
  const [docSubmitting, setDocSubmitting] = useState(false);

  // ------- Add Student -----
  const [newStudent, setNewStudent] = useState("");
  const [newStdEmail, setNewStdEmail] = useState("");
  const [newClassOrgId, setNewClassOrgId] = useState("");
  const [stdClass, setStdClass] = useState("");
  const [selectedSpecializationId, setSelectedSpecializationId] = useState("");
  const [stdUsername, setStdUsername] = useState("");
  const [stdPassword, setStdPassword] = useState("");

  // ------- Add Student (Excel bulk) -----
  const [studentInputMode, setStudentInputMode] = useState("single"); // "single" | "excel"
  const [excelFileName, setExcelFileName] = useState("");
  const [excelStudentRows, setExcelStudentRows] = useState([]); // [{ name }]
  const [bulkSubmitting, setBulkSubmitting] = useState(false);
  const [bulkResults, setBulkResults] = useState([]);

  useEffect(() => {
    const loadAll = async () => {
      const [coursesRes, specsRes, schoolRes, classRoomsRes, stagesRes] = await Promise.all([
        fetchWatomsRelatedCoursesDetailed(),
        fetchWisdomRelatedSpecializations(),
        fetchWisdomRelatedSchools(),
        fetchWisdomRelatedClassRooms(),
        fetchWisdomStages()
      ]);

      setCourses(coursesRes);
      setFilteredCourses(coursesRes);
      setSpecializations(specsRes);
      setFilteredSpecializations(specsRes)
      setSchools(schoolRes);
      setClassRooms(classRoomsRes);
      setFilteredClassRooms(classRoomsRes);
      setStages(stagesRes);
    };

    loadAll();
  }, []);

  const handleAddClassRoom = async (e) => {
    e.preventDefault();

    if (!newClassRoomName || !newClassRoomOrgId) {
      toast.error(language ? "Fill all fields" : "املأ كل الحقول");
      return;
    }

    try {
      const created = await createClassRoom({
        Name: newClassRoomName,
        organization_id: Number(newClassRoomOrgId),
        room_type: newRoomType,
      });

      setClassRooms((prev) => [created, ...prev]);
      setFilteredClassRooms((prev) => [created, ...prev]);

      setNewClassRoomName("");
      setNewClassRoomOrgId("");

      toast.success(language ? "Classroom added" : "تم إضافة القاعة");
    } catch (err) {
      toast.error(language ? "Failed to add classroom" : "فشل إضافة القاعة");
    }
  };

  const handleAddClass = async (e) => {
    e.preventDefault();

    if (!newClassName || !newClassRoomId) {
      toast.error(language ? "Fill required fields" : "املأ الحقول المطلوبة");
      return;
    }

    try {

      const created = await createClass({
        name: newClassName,
        classRoom_id: Number(newClassRoomId),
        specialization_id: newSpecializationId ? Number(newSpecializationId) : null,
        stage_id: stageId ? Number(stageId) : null,
        start_date: newStartDate || null,
        end_date: newEndDate || null,
        hours: Number(newHours) || 0,
        no_of_male_students: Number(newMale) || 0,
        no_of_female_students: Number(newFemale) || 0,
        status: newStatus || "ongoing",
      });

      const createdCourse = {
        ...created,
        classRoom: classRooms.find((cr) => cr.id === Number(newClassRoomId)) || null,
        specialization: specializations.find((s) => s.id === Number(newSpecializationId)) || null,
        sessions: [],
      };

      setCourses((prev) => [createdCourse, ...prev]);

      // reset
      setNewClassName("");
      setNewClassRoomId("");
      setNewSpecializationId("");
      setNewStartDate("");
      setNewEndDate("");
      setNewHours("");
      setNewMale("");
      setNewFemale("");
      setNewStatus("");

      toast.success(language ? "Course added" : "تم إضافة الدورة");
    } catch (err) {
      toast.error(language ? "Failed to add course" : "فشل إضافة الدورة");
    }
  };

  const handleAddStudent = async (e) => {
    e.preventDefault();

    if (studentInputMode === "excel") {
      await handleAddStudentsBulk();
      return;
    }

    const password = Math.floor(100000 + Math.random() * 900000);
    const [first_name, middle_name, last_name] = newStudent.trim().split(/\s+/);

    const stdData = {
      first_name,
      middle_name,
      last_name,
      email: newStdEmail || "test@test.com",
      user_role_id: 19,
      class_id: Number(stdClass),
      specialization_id: Number(selectedSpecializationId),
      organization_id: Number(newClassOrgId),
      password: String(password)
    }

    try {
      const response = await signUpUser(stdData)
      setStdUsername(response?.code)
      setStdPassword(password)
      toast.success(language ? "Course added" : "تم إضافة الدورة");
    } catch (err) {
      toast.error(language ? "Failed to add course" : "فشل إضافة الدورة");
    }
  };

  const handleExcelUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setExcelFileName(file.name);
    setBulkResults([]);

    const reader = new FileReader();
    reader.onload = (evt) => {
      const wb = XLSX.read(evt.target.result, { type: "binary" });
      const ws = wb.Sheets[wb.SheetNames[0]];
      const data = XLSX.utils.sheet_to_json(ws, { header: 1, defval: "" });

      const rows = data
        .slice(1) // first row is treated as header
        .map((row) => row[0]?.toString().trim())
        .filter((name) => name);

      setExcelStudentRows(rows.map((name) => ({ name })));
    };
    reader.readAsBinaryString(file);
  };

  const handleAddStudentsBulk = async () => {
    if (excelStudentRows.length === 0) {
      toast.error(language ? "Upload an excel file first" : "قم برفع ملف اكسل أولاً");
      return;
    }

    if (!stdClass || !selectedSpecializationId || !newClassOrgId) {
      toast.error(language ? "Fill all fields" : "املأ كل الحقول");
      return;
    }

    const invalidRows = excelStudentRows.filter(
      (row) => row.name.split(/\s+/).length < 3
    );

    if (invalidRows.length > 0) {
      const invalidNames = invalidRows.map((r) => `"${r.name}"`).join(", ");
      toast.error(
        language
          ? `These names need at least a first, middle and last name: ${invalidNames}`
          : `هذه الأسماء تحتاج على الأقل اسم أول وأوسط وأخير: ${invalidNames}`
      );
      return;
    }

    setBulkSubmitting(true);
    const results = [];

    for (const row of excelStudentRows) {
      const [first_name, middle_name, last_name] = row.name.split(/\s+/);
      const password = Math.floor(100000 + Math.random() * 900000);

      const stdData = {
        first_name,
        middle_name,
        last_name,
        email: "test@test.com",
        user_role_id: 19,
        class_id: Number(stdClass),
        specialization_id: Number(selectedSpecializationId),
        organization_id: Number(newClassOrgId),
        password: String(password)
      };

      try {
        const response = await signUpUser(stdData);
        results.push({
          Name: row.name,
          Code: response?.code || "",
          Password: password,
          Issue: ""
        });
      } catch (err) {
        const issue =
          err.response?.data?.message ||
          err.response?.data?.error ||
          err.message ||
          (language ? "Unknown error" : "خطأ غير معروف");
        results.push({
          Name: row.name,
          Code: "",
          Password: "",
          Issue: issue
        });
      }
    }

    setBulkResults(results);
    setBulkSubmitting(false);
    setExcelStudentRows([]);
    setExcelFileName("");

    const successCount = results.filter((r) => !r.Issue).length;
    const failCount = results.length - successCount;

    toast.success(
      language
        ? `Done: ${successCount} added, ${failCount} failed`
        : `تم: ${successCount} تمت الإضافة، ${failCount} فشل`
    );
  };

  const downloadBulkResults = () => {
    if (!bulkResults.length) return;

    const worksheet = XLSX.utils.json_to_sheet(bulkResults);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Students");

    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "students_results.xlsx");
  };

  const filterClassRooms = async (value) => {
    setNewClassRoomOrgId(value);
    const filterClassRooms = classRooms.filter(c => c.organization_id === Number(value));
    setFilteredClassRooms(filterClassRooms);
    const filterSpecializations = specializations.filter(spec => spec.organizations?.some(org => org.id === Number(value)))
    setFilteredSpecializations(filterSpecializations)
  }

  const filterCourses = async (value) => {
    setNewClassOrgId(value);
    const filterClasses = courses.filter(c => c.classRoom.organization_id === Number(value));
    setFilteredCourses(filterClasses)
  }

  const filterDocClassRooms = (orgId, roomType) => {
    const filtered = classRooms.filter((c) => {
      const matchesOrg = orgId ? c.organization_id === Number(orgId) : true;
      const matchesType = roomType ? c.room_type === roomType : true;
      return matchesOrg && matchesType;
    });
    setFilteredDocClassRooms(filtered);
  };

  const handleDocOrgChange = (value) => {
    setDocOrgId(value);
    setDocClassRoomId("");
    filterDocClassRooms(value, docRoomType);
  };

  const handleDocRoomTypeChange = (value) => {
    setDocRoomType(value);
    setDocClassRoomId("");
    filterDocClassRooms(docOrgId, value);
  };

  const handleDocFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setDocFile(file);
    setDocFileName(file.name);
  };

  const handleAddClassRoomDocument = async (e) => {
    e.preventDefault();

    if (!docOrgId || !docRoomType || !docClassRoomId || !docFile) {
      toast.error(language ? "Fill all fields" : "املأ كل الحقول");
      return;
    }
    console.log(ebdaUserInfo)
    const formData = new FormData();
    formData.append("organization_id", docOrgId);
    formData.append("room_type", docRoomType);
    formData.append("classroom_id", docClassRoomId);
    formData.append("user_id", ebdaUserInfo?.id);
    formData.append("file", docFile);

    setDocSubmitting(true);
    try {
      await uploadClassRoomDocument(formData);

      setDocOrgId("");
      setDocRoomType("class");
      setDocClassRoomId("");
      setFilteredDocClassRooms([]);
      setDocFile(null);
      setDocFileName("");

      toast.success(language ? "Document uploaded" : "تم رفع المستند");
    } catch (err) {
      toast.error(language ? "Failed to upload document" : "فشل رفع المستند");
    } finally {
      setDocSubmitting(false);
    }
  };

  return (
    <div className={`w-full min-h-screen flex flex-col items-center ${darkMode && "bg-watomsBlue text-white"}`}>
      <EbdaEduNavbar />
      {/* Add Forms (Accordion) */}
      <div className="w-[90%] mb-6 space-y-4" dir={language ? "ltr" : "rtl"}>

        {/* Add Classroom */}
        <div
          className={`rounded-2xl border shadow-sm overflow-hidden ${darkMode ? "bg-white text-black border-black/10" : "bg-white border-slate-200"
            }`}
        >
          {/* Header */}
          <button
            type="button"
            onClick={() => setOpenForm(openForm === "classroom" ? null : "classroom")}
            className="w-full px-4 py-3 flex items-center justify-between font-bold"
          >
            <span>{language ? "Add Lab / Workshop / Class" : "إضافة معمل / ورشة / فصل"}</span>
            <span className={`transition-transform duration-300 ${openForm === "classroom" ? "rotate-180" : ""}`}>
              <FontAwesomeIcon icon={faChevronDown} className="text-slate-500" />
            </span>
          </button>

          {/* Body */}
          <div className={`transition-all duration-300 overflow-hidden ${openForm === "classroom" ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0"}`}>
            <form onSubmit={handleAddClassRoom} className="p-4 pt-0 space-y-3">
              <input
                className="w-full rounded-xl px-3 py-2 border border-slate-200 outline-none"
                placeholder={language ? "Name" : "الاسم"}
                value={newClassRoomName}
                onChange={(e) => setNewClassRoomName(e.target.value)}
              />

              {/* ✅ NEW: Room Type */}
              <select
                className="w-full rounded-xl px-3 py-2 border border-slate-200 outline-none"
                value={newRoomType}
                onChange={(e) => setNewRoomType(e.target.value)}
              >
                <option value="lab">{language ? "Lab" : "معمل"}</option>
                <option value="workshop">{language ? "Workshop" : "ورشة"}</option>
                <option value="class">{language ? "Class" : "فصل"}</option>
              </select>

              <select
                className="w-full rounded-xl px-3 py-2 border border-slate-200 outline-none"
                value={newClassRoomOrgId}
                onChange={(e) => setNewClassRoomOrgId(e.target.value)}
              >
                <option value="">{language ? "Select VTC" : "اختر المركز"}</option>
                {schools?.map((vtc) => (
                  <option key={vtc.id} value={vtc.id}>
                    {vtc.name}
                  </option>
                ))}
              </select>

              <button
                type="submit"
                className="w-full rounded-xl py-2 font-semibold bg-blue-600 text-white hover:bg-blue-700"
              >
                {language ? "Add Classroom" : "إضافة القاعة"}
              </button>
            </form>
          </div>
        </div>

        {/* Add Classroom Document */}
        <div
          className={`rounded-2xl border shadow-sm overflow-hidden ${darkMode ? "bg-white text-black border-black/10" : "bg-white border-slate-200"
            }`}
        >
          {/* Header */}
          <button
            type="button"
            onClick={() => setOpenForm(openForm === "document" ? null : "document")}
            className="w-full px-4 py-3 flex items-center justify-between font-bold"
          >
            <span>{language ? "Add Classroom Document" : "إضافة مستند القاعة"}</span>
            <span className={`transition-transform duration-300 ${openForm === "document" ? "rotate-180" : ""}`}>
              <FontAwesomeIcon icon={faChevronDown} className="text-slate-500" />
            </span>
          </button>

          {/* Body */}
          <div className={`transition-all duration-300 overflow-hidden ${openForm === "document" ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0"}`}>
            <form onSubmit={handleAddClassRoomDocument} className="p-4 pt-0 space-y-3">
              <select
                className="w-full rounded-xl px-3 py-2 border border-slate-200 outline-none"
                value={docOrgId}
                onChange={(e) => handleDocOrgChange(e.target.value)}
              >
                <option value="">{language ? "Select VTC" : "اختر المركز"}</option>
                {schools?.map((vtc) => (
                  <option key={vtc.id} value={vtc.id}>
                    {vtc.name}
                  </option>
                ))}
              </select>

              <select
                className="w-full rounded-xl px-3 py-2 border border-slate-200 outline-none"
                value={docRoomType}
                onChange={(e) => handleDocRoomTypeChange(e.target.value)}
              >
                <option value="lab">{language ? "Lab" : "معمل"}</option>
                <option value="workshop">{language ? "Workshop" : "ورشة"}</option>
                <option value="class">{language ? "Class" : "فصل"}</option>
              </select>

              <select
                className="w-full rounded-xl px-3 py-2 border border-slate-200 outline-none"
                value={docClassRoomId}
                onChange={(e) => setDocClassRoomId(e.target.value)}
              >
                <option value="">{language ? "Select Classroom" : "اختر القاعة"}</option>
                {filteredDocClassRooms?.map((cr) => (
                  <option key={cr.id} value={cr.id}>
                    {cr.Name}
                  </option>
                ))}
              </select>

              <div className="space-y-2">
                <input
                  type="file"
                  onChange={handleDocFileUpload}
                  className="w-full rounded-xl px-3 py-2 border border-slate-200 outline-none file:mr-3 file:py-1 file:px-3 file:rounded file:border-0 file:text-sm file:bg-blue-100 file:text-blue-700"
                />
                {docFileName && (
                  <p className="text-xs text-slate-600">
                    {language ? "File" : "الملف"}: {docFileName}
                  </p>
                )}
              </div>

              <button
                type="submit"
                disabled={docSubmitting}
                className="w-full rounded-xl py-2 font-semibold bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-60"
              >
                {docSubmitting
                  ? (language ? "Uploading..." : "جاري الرفع...")
                  : (language ? "Add Classroom Document" : "إضافة مستند القاعة")}
              </button>
            </form>
          </div>
        </div>

        {/* Add Class */}
        <div
          className={`rounded-2xl border shadow-sm overflow-hidden ${darkMode ? "bg-white text-black border-black/10" : "bg-white border-slate-200"
            }`}
        >
          {/* Header */}
          <button
            type="button"
            onClick={() => setOpenForm(openForm === "class" ? null : "class")}
            className="w-full px-4 py-3 flex items-center justify-between font-bold"
          >
            <span>{language ? "Add Class" : "إضافة دورة"}</span>
            <span className={`transition-transform duration-300 ${openForm === "class" ? "rotate-180" : ""}`}>
              <FontAwesomeIcon icon={faChevronDown} className="text-slate-500" />
            </span>
          </button>

          {/* Body */}
          <div className={`transition-all duration-300 overflow-hidden ${openForm === "class" ? "max-h-[900px] opacity-100" : "max-h-0 opacity-0"}`}>
            <form onSubmit={handleAddClass} className="p-4 pt-0 space-y-3">
              <input
                className="w-full rounded-xl px-3 py-2 border border-slate-200 outline-none"
                placeholder={language ? "Class name" : "اسم الدورة"}
                value={newClassName}
                onChange={(e) => setNewClassName(e.target.value)}
              />

              <select
                className="w-full rounded-xl px-3 py-2 border border-slate-200 outline-none"
                value={newClassRoomOrgId}
                onChange={(e) => filterClassRooms(e.target.value)}
              >
                <option value="">{language ? "Select School" : "اختر المدرسة"}</option>
                {schools?.map((school) => (
                  <option key={school.id} value={school.id}>
                    {school.name}
                  </option>
                ))}
              </select>

              <select
                className="w-full rounded-xl px-3 py-2 border border-slate-200 outline-none"
                value={newClassRoomId}
                onChange={(e) => setNewClassRoomId(e.target.value)}
              >
                <option value="">{language ? "Select Classroom" : "اختر القاعة"}</option>
                {filteredClassRooms?.map((cr) => (
                  <option key={cr.id} value={cr.id}>
                    {cr.Name}
                  </option>
                ))}
              </select>

              <select
                className="w-full rounded-xl px-3 py-2 border border-slate-200 outline-none"
                value={newSpecializationId}
                onChange={(e) => setNewSpecializationId(e.target.value)}
              >
                <option value="">{language ? "Select Specialization" : "اختر التخصص"}</option>
                {filteredSpecializations?.map((sp) => (
                  <option key={sp.id} value={sp.id}>
                    {sp.name}
                  </option>
                ))}
              </select>

              <select
                className="w-full rounded-xl px-3 py-2 border border-slate-200 outline-none"
                value={stageId}
                onChange={(e) => setStageId(e.target.value)}
              >
                <option value="">{language ? "Select Stage" : "اختر المرحلة التعليمية"}</option>
                {stages?.map((stage) => (
                  <option key={stage.id} value={stage.id}>
                    {stage.name}
                  </option>
                ))}
              </select>

              <div className="grid grid-cols-2 gap-3">
                <input
                  type="date"
                  className="w-full rounded-xl px-3 py-2 border border-slate-200 outline-none"
                  value={newStartDate}
                  onChange={(e) => setNewStartDate(e.target.value)}
                />
                <input
                  type="date"
                  className="w-full rounded-xl px-3 py-2 border border-slate-200 outline-none"
                  value={newEndDate}
                  onChange={(e) => setNewEndDate(e.target.value)}
                />
              </div>

              <div className="grid grid-cols-3 gap-3">
                <input
                  className="w-full rounded-xl px-3 py-2 border border-slate-200 outline-none"
                  placeholder={language ? "Hours" : "الساعات"}
                  value={newHours}
                  onChange={(e) => setNewHours(e.target.value)}
                />
                <input
                  className="w-full rounded-xl px-3 py-2 border border-slate-200 outline-none"
                  placeholder={language ? "Male" : "ذكور"}
                  value={newMale}
                  onChange={(e) => setNewMale(e.target.value)}
                />
                <input
                  className="w-full rounded-xl px-3 py-2 border border-slate-200 outline-none"
                  placeholder={language ? "Female" : "إناث"}
                  value={newFemale}
                  onChange={(e) => setNewFemale(e.target.value)}
                />
              </div>

              <select
                className="w-full rounded-xl px-3 py-2 border border-slate-200 outline-none"
                value={newStatus}
                onChange={(e) => setNewStatus(e.target.value)}
              >
                <option value="">{language ? "Select Status" : "اختر الحالة"}</option>
                {CLASS_STATUS?.map((st) => (
                  <option key={st} value={st}>
                    {st}
                  </option>
                ))}
              </select>

              <button
                type="submit"
                className="w-full rounded-xl py-2 font-semibold bg-green-600 text-white hover:bg-green-700"
              >
                {language ? "Add Class" : "إضافة الدورة"}
              </button>
            </form>
          </div>
        </div>

        {/* Add Student */}
        <div className={`rounded-2xl border shadow-sm overflow-hidden ${darkMode ? "bg-white text-black border-black/10" : "bg-white border-slate-200"}`} >
          {/* Header */}
          <button
            type="button"
            onClick={() => setOpenForm(openForm === "student" ? null : "student")}
            className="w-full px-4 py-3 flex items-center justify-between font-bold"
          >
            <span>{language ? "Add Student" : "إضافة طالب"}</span>
            <span className={`transition-transform duration-300 ${openForm === "student" ? "rotate-180" : ""}`}>
              <FontAwesomeIcon icon={faChevronDown} className="text-slate-500" />
            </span>
          </button>

          {/* Body */}
          <div className={`transition-all duration-300 overflow-hidden ${openForm === "student" ? "max-h-[900px] opacity-100" : "max-h-0 opacity-0"}`}>
            <form onSubmit={handleAddStudent} className="p-4 pt-0 space-y-3">
              <div className="flex gap-2">
                <button
                  type="button"
                  onClick={() => setStudentInputMode("single")}
                  className={`flex-1 rounded-xl py-2 font-semibold border ${studentInputMode === "single"
                    ? "bg-blue-600 text-white border-blue-600"
                    : "bg-white text-slate-700 border-slate-200"
                    }`}
                >
                  {language ? "Single Student" : "طالب واحد"}
                </button>
                <button
                  type="button"
                  onClick={() => setStudentInputMode("excel")}
                  className={`flex-1 rounded-xl py-2 font-semibold border ${studentInputMode === "excel"
                    ? "bg-blue-600 text-white border-blue-600"
                    : "bg-white text-slate-700 border-slate-200"
                    }`}
                >
                  {language ? "Upload Excel" : "رفع ملف اكسل"}
                </button>
              </div>

              {studentInputMode === "single" ? (
                <>
                  <input
                    className="w-full rounded-xl px-3 py-2 border border-slate-200 outline-none"
                    placeholder={language ? "Student name" : "اسم الطالب"}
                    value={newStudent}
                    onChange={(e) => setNewStudent(e.target.value)}
                  />

                  <input
                    className="w-full rounded-xl px-3 py-2 border border-slate-200 outline-none"
                    placeholder={language ? "Email" : "البريد الالكتروني"}
                    value={newStdEmail}
                    onChange={(e) => setNewStdEmail(e.target.value)}
                  />
                </>
              ) : (
                <div className="space-y-2">
                  <input
                    type="file"
                    accept=".xlsx, .xls"
                    onChange={handleExcelUpload}
                    className="w-full rounded-xl px-3 py-2 border border-slate-200 outline-none file:mr-3 file:py-1 file:px-3 file:rounded file:border-0 file:text-sm file:bg-blue-100 file:text-blue-700"
                  />
                  <p className="text-xs text-slate-500">
                    {language
                      ? "First row is treated as a header. Put the full student name (first middle last) in the first column of each following row."
                      : "الصف الأول يعتبر عنوانًا. ضع اسم الطالب الكامل (أول أوسط أخير) في العمود الأول بكل صف بعده."}
                  </p>
                  {excelFileName && (
                    <p className="text-xs text-slate-600">
                      {language ? "File" : "الملف"}: {excelFileName} — {excelStudentRows.length}{" "}
                      {language ? "students found" : "طالب"}
                    </p>
                  )}
                </div>
              )}

              <select
                className="w-full rounded-xl px-3 py-2 border border-slate-200 outline-none"
                value={newClassOrgId}
                onChange={(e) => filterCourses(e.target.value)}
              >
                <option value="">{language ? "Select School" : "اختر المدرسة"}</option>
                {schools?.map((school) => (
                  <option key={school.id} value={school.id}>
                    {school.name}
                  </option>
                ))}
              </select>

              <select
                className="w-full rounded-xl px-3 py-2 border border-slate-200 outline-none"
                value={stdClass}
                onChange={(e) => setStdClass(e.target.value)}
              >
                <option value="">{language ? "Select Class" : "اختر الفصل"}</option>
                {filteredCourses?.map((course) => (
                  <option key={course.id} value={course.id}>
                    {course.name}
                  </option>
                ))}
              </select>

              <select
                className="w-full rounded-xl px-3 py-2 border border-slate-200 outline-none"
                value={selectedSpecializationId}
                onChange={(e) => setSelectedSpecializationId(e.target.value)}
              >
                <option value="">{language ? "Select Specialization" : "اختر التخصص"}</option>
                {filteredSpecializations?.map((sp) => (
                  <option key={sp.id} value={sp.id}>
                    {sp.name}
                  </option>
                ))}
              </select>

              <button
                type="submit"
                disabled={bulkSubmitting}
                className="w-full rounded-xl py-2 font-semibold bg-green-600 text-white hover:bg-green-700 disabled:opacity-60"
              >
                {bulkSubmitting
                  ? (language ? "Processing..." : "جاري المعالجة...")
                  : (language ? "Add Student" : "إضافة طالب")}
              </button>
            </form>

            {bulkResults.length > 0 && (
              <div className="p-4 pt-0">
                <button
                  type="button"
                  onClick={downloadBulkResults}
                  className="w-full rounded-xl py-2 font-semibold bg-purple-600 text-white hover:bg-purple-700"
                >
                  {language ? "Download Results" : "تحميل النتائج"}
                </button>
              </div>
            )}
          </div>
        </div>

        {stdUsername && stdPassword && <div className="flex justify-evenly">
          <p>password: {stdPassword}</p>
          <p>username: {stdUsername}</p>
        </div>}
      </div>
    </div>
  );
};

export default WabysBulkStudents;